import { render, staticRenderFns } from "./OfficeCarousel.vue?vue&type=template&id=0cfdf6b2&scoped=true&"
import script from "./OfficeCarousel.vue?vue&type=script&lang=ts&"
export * from "./OfficeCarousel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfdf6b2",
  null
  
)

export default component.exports